export const paths = {
  login: '/login',
  // PC-FINAL-3: recuperación de contraseña -- sin autenticar, mismo
  // AuthLayout que /login.
  forgotPassword: '/recuperar-contrasena',
  resetPassword: '/restablecer-contrasena',
  // Centro de Inteligencia — pantalla principal (antes "Dashboard").
  dashboard: '/',
  pulse: '/pulso-municipal',
  territorial: '/inteligencia-territorial',
  signals: '/senales-y-alertas',
  topics: '/temas-estrategicos',
  evolution: '/evolucion',
  assistant: '/govia-ai',
  documents: '/evidencia',
  reports: '/reportes-ejecutivos',
  dependencies: '/dependencias',
  sourceHub: '/centro-de-fuentes',
  organization: '/organizacion',
  users: '/usuarios',
  audit: '/auditoria',
  settings: '/configuracion',
  // GOVIA UI V2 (Fase 0) — capa de experiencia en paralelo, ver /CLAUDE.md.
  // No sustituye ninguna ruta existente arriba.
  v2: '/v2',
  v2Territory: '/v2/territory',
  // UX-2.5 — Client Monitoring, workspace nativo (reemplaza el puente
  // temporal de UX-2.1 hacia el /centro-de-fuentes clásico como destino
  // de "Monitoreo" en la navegación V2; la página clásica se conserva
  // intacta para gestión real de fuentes, ver navigation.ts).
  v2Monitoring: '/v2/monitoring',
  // UX-2.6 — Client Risks + Alerts, workspaces nativos. Riesgos no tenía
  // ningún destino real (UX-2.1 lo dejó "Próximamente"); Alertas
  // reemplaza el puente hacia /senales-y-alertas (dashboard AlertsWidget,
  // más limitado) por un workspace nativo sobre decisionCenterApi
  // (dominio/escalación reales, ya certificado en /v2/strategy).
  v2Risks: '/v2/risks',
  v2Alerts: '/v2/alerts',
  // PC-4 — Prediction & Scenarios Workspace, nativo de V2 (sin
  // equivalente en V1: /evolucion es histórico puro, sin predicción).
  v2Predictions: '/v2/predictions',
  // UX-2.7 — Decision Center + Recomendaciones, workspaces nativos.
  // Ambos estaban "Próximamente" desde UX-2.1.
  v2Decisions: '/v2/decisions',
  v2Recommendations: '/v2/recommendations',
  v2Assistant: '/v2/assistant',
  v2Strategy: '/v2/strategy',
  v2DesignSystem: '/v2/design-system',
  // Fase 9 (Controlled Pre-Migration) — alias cortos NO destructivos hacia
  // las mismas páginas V2 de arriba. Sin V1 equivalente en estas rutas
  // exactas, así que renderizan V2 siempre, sin importar
  // VITE_GOVIA_UI_VERSION (no hay nada que "cortar" aquí).
  territorio: '/territorio',
  estrategia: '/estrategia',
  // Cutover controlado (autorizado) — V1 sigue disponible aquí siempre,
  // sin importar el switch, para rollback/referencia inmediata. '/' y
  // '/govia-ai' arriba ahora sirven V1 o V2 según VITE_GOVIA_UI_VERSION
  // (ver VersionGate en AppRoutes.tsx); estas dos rutas SIEMPRE sirven V1.
  legacyDashboard: '/legacy/dashboard',
  legacyAssistant: '/legacy/assistant',
  // GOVIA SUPER ADMIN (SA-3) — Platform Console, producto separado del
  // cliente (ver CLAUDE.md / encargo SA-3). Nunca se mezcla con las rutas
  // de arriba; protegido por PlatformOperatorRoute, no por PermissionRoute.
  superAdmin: '/super-admin',
  superAdminOrganizations: '/super-admin/organizations',
  superAdminOrganizationDetail: '/super-admin/organizations/:organizationId',
  superAdminAiUsage: '/super-admin/ai-usage',
  superAdminSources: '/super-admin/sources',
  superAdminUsers: '/super-admin/users',
  superAdminHealth: '/super-admin/health',
  superAdminAudit: '/super-admin/audit',
  // SA-6 (Commercial Entitlement & Contract Management) — catálogo de
  // planes; los contratos viven dentro de la ficha de cada organización
  // (Organization Detail → pestaña "Plan y contrato"), no hay una lista
  // global de contratos cross-tenant (ver reporte SA-6, Sección FRONTEND).
  superAdminPlans: '/super-admin/plans',
  // Platform Console: Costos IA (plataforma + por organización) y
  // configuración de plataforma.
  superAdminCosts: '/super-admin/costs',
  superAdminSettings: '/super-admin/settings',
  // GOVIA Agentic A9 — Agent Ops (solo operadores de plataforma, mismo
  // árbol protegido por PlatformOperatorRoute).
  superAdminAgentOps: '/super-admin/agent-ops',
  superAdminAgentOpsRuns: '/super-admin/agent-ops/runs',
  superAdminAgentOpsPipeline: '/super-admin/agent-ops/pipeline/:stage',
  superAdminAgentOpsApprovals: '/super-admin/agent-ops/approvals',
  superAdminAgentOpsEvaluations: '/super-admin/agent-ops/evaluations',
  superAdminAgentOpsControls: '/super-admin/agent-ops/controls',
  superAdminAgentOpsCosts: '/super-admin/agent-ops/costs',
  superAdminAgentOpsOrganization: '/super-admin/agent-ops/organizations/:organizationId',
  notFound: '*',
} as const

export function superAdminOrganizationDetailPath(organizationId: string): string {
  return `/super-admin/organizations/${organizationId}`
}

export function agentOpsPipelinePath(stage: 'collection' | 'evidence' | 'intelligence' | 'prediction'): string {
  return `/super-admin/agent-ops/pipeline/${stage}`
}

export function agentOpsOrganizationPath(organizationId: string): string {
  return `/super-admin/agent-ops/organizations/${organizationId}`
}
